/**
 * comes from, may be refactored once extracted from the main repository
 * https://github.com/directus/monospace/tree/main/app/src/utils/readable-mime-type
 */

import colors from './colors.json';
import extensions from './extensions.json';
import types from './types.json';

export function mediaTypeDisplayName(type: string) {
	return (types as Record<string, string>)[type] || null;
}

export function mediaTypeExtension(type: string) {
	return (extensions as Record<string, string>)[type] || null;
}

export function mediaTypeColor(type: string) {
	return (colors as Record<string, string>)[type] || null;
}
